<template>
  <div
    class="lib-temp-loading"
    :style="{width:this.Window_Size.width+'px', height:this.Window_Size.height+'px'}"
  >
    <div
      class="loading-icon"
      :style="{width: dialogSize.width + 'px',height: dialogSize.height + 'px', left: dialogSize.left + 'px', top: dialogSize.top + 'px'}"
    >
      <span>正在加载场景页数据...</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["Window_Size"]),
    dialogSize() {
      let width = 300;
      let height = 100;
      let left = (this.Window_Size.width - width) / 2;
      let top = (this.Window_Size.height - height) / 2;
      return {
        width,
        height,
        left,
        top
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.lib-temp-loading {
  background: #ffffff77;
  .loading-icon {
    position: absolute;
    background-color: #ffffff;
    box-shadow: 0px 0px 6px 0px rgba(71, 66, 97, 0.2);
    border-radius: 8px;
    span {
      line-height: 100px;
      width: 155px;
      height: 17px;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #474261;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/emodal/templateLib/firstTemplateLoadingMask.vue